<template>
  <div data-testid="analise-laudos-page-root">
    <box :title="t('Análise de Laudos')">
      <SOLaudosAnalysisTable ref="analysisTableRef" />
    </box>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import { log } from '../../utils/DebugLogger';

const { t } = useI18n();

interface TableInstance {
  loadData: () => void;
}

const analysisTableRef = ref<TableInstance | null>(null);

const loadData = async (): Promise<void> => {
  if (analysisTableRef.value) {
    await analysisTableRef.value.loadData();
  }
};

onMounted(() => {
  log('SOLaudosAnalysisPage', 'mounted', 'Component mounted');
});

onBeforeUnmount(() => {
  log('SOLaudosAnalysisPage', 'beforeUnmount', 'Cleaning up');
});

defineExpose({ loadData });
</script>

<style scoped>
</style>
